import React from 'react'
import * as yup from 'yup'
import { useContext, useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { useApiCall } from '../../../../component/custom-hooks/api-call'
import Swal from 'sweetalert2'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import { format } from 'date-fns'
import { Alert, Snackbar } from '@mui/material'
import { FormArea, FeildWraper, FormLineBreak, FormHeading1, SelectSearch, FeildError, FormLabel } from '../../../../component/form/form-layout'
import { GlobalContext } from '../../../../context/Context'


const validationSchema = yup.object().shape({
    name: yup.string().required('Name is required'),
    email: yup.string().email('Invalid email').required('Email is required'),
    password: yup.string().required('Password is required'),
    password_confirmation: yup.string().oneOf([yup.ref('password')], 'Passwords must match').required('Confirm your password'),
    department: yup.string().required('Select a department'),
    designation: yup.string().required('Designation is required'),
    employee_type: yup.string().required('Select employee type'),
    job_type: yup.string().required('Select job type'),
    reporting_authority: yup.string().required('Select reporting authority'),
    salary: yup.number().required('Salary is required'),
    role: yup.string().required('Role is required'),
    shift: yup.string().required('Select shift'),
    joining_date: yup.string().required('Joining date is required'),
});

const AddUpdateEmployee = ({ Style, data, onClose = () => { }, onChange = () => { } }) => {
    const apiCall = useApiCall();
    let { state } = useContext(GlobalContext);
    const [deptUserList, setDeptUserList] = useState([]);
    const [alertData, setAlertData] = useState({ isShow: false });

    const handleClose = () => {
        setAlertData({ isShow: false })
    }
    const onApplyError = (message) => {
        setAlertData({ isShow: true, type: "error", message: message })
    }
    const formik = useFormik({
        initialValues: {
            name: data?.name || "",
            email: data?.email || "",
            password: data?.employee_id ? "**********" : "",
            password_confirmation: data?.employee_id ? "**********" : "",
            department: data?.department || "",
            designation: data?.designation || "",
            employee_type: data?.emp_emptype || "",
            job_type: data?.emp_jobtype || "",
            reporting_authority: data?.emp_reportingauthority || "",
            salary: data?.emp_salary || "",
            role: data?.emp_role || "",
            shift: data?.emp_shift_id || "",
            joining_date: data?.date_of_joining ? new Date(data.date_of_joining) : "",
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {
            let extraField = {}
            let id = data?.employee_id;

            if (id) {
                extraField = {
                    "employee_id": id,
                    "email": values?.email,
                    "name": values?.name,
                    "department_id": values.department,
                    "ra_id": values.reporting_authority,
                    "designation": values.designation,
                    "jobtype": values.job_type,
                    "salary": values.salary,
                    "shift": values.shift,
                    "dateofjoining": formik.values.joining_date ? format(new Date(formik.values.joining_date), "yyyy-MM-dd") : null,
                    "employee_type": values.employee_type,
                    "role": values.role,
                }
            }

            if (!id) {
                extraField = {
                    "password": values?.password,
                    "password_confirmation": values.password_confirmation,
                    "name": values?.name,
                    "email": values?.email,
                    "p_reporting_authority": values.reporting_authority,
                    p_joining_date: formik.values.joining_date
                        ? format(new Date(formik.values.joining_date), "yyyy-MM-dd")
                        : null,
                    "p_department": values.department,
                    "p_designation": values.designation,
                    "p_employee_type": values.employee_type,
                    "p_job_type": values.job_type,
                    "p_user_type": "9",
                    "p_salary": values.salary,
                    "p_role": values.role,
                    "p_shift": values.shift
                }
            }

            // Perform API POST here
            let apiData = JSON.stringify({
                ...extraField,
            });
            try {
                if (data?.employee_id) {
                    let resp = await apiCall({ method: 'post', url: `update-employee-data`, data: apiData });
                    Swal.fire(
                        'Submitted!',
                        resp?.message,
                        'success'
                    )

                    formik.resetForm();
                    popupClosed();
                    onChange();
                } else {
                    let resp = await apiCall({ method: 'post', url: `add-employee`, data: apiData });
                    Swal.fire(
                        'Submitted!',
                        resp?.message,
                        'success'
                    )

                    formik.resetForm();
                    popupClosed();
                    onChange();
                }
            } catch (error) {
                onApplyError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
                console.warn("Error : ", error)
            }
        }
    });
    const popupClosed = () => {
        onClose();
    }
    const getDeptUsersList = async (deptId) => {
        try {
            let res = await apiCall({ method: 'get', url: `get-dept-users-list/${deptId}` });
            setDeptUserList(res?.deptUsersList);
        } catch (error) {
            console.warn("Error : ", error)
        }
    }

    useEffect(() => {
        let id = data?.employee_id;

        if (id) {
            getDeptUsersList(data?.department);
        }
    }, [data?.employee_id]);
    
    return (
        <>
            <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
                <div className={Style.modal_body}>
                    <FormArea>
                        <FormHeading1>User Account Information</FormHeading1>
                        <FeildWraper>
                            <FormLabel required>Name</FormLabel>
                            <input
                                type={'text'}
                                name={'name'}
                                onChange={formik.handleChange}
                                value={formik.values.name}
                                placeholder='Name'
                            />
                            {formik.touched.name && formik.errors.name && (
                                <FeildError>{formik.errors.name}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Email</FormLabel>
                            <input
                                type={'text'}
                                name={'email'}
                                onChange={formik.handleChange}
                                value={formik.values.email}
                                placeholder='Email'
                            />
                            {formik.touched.email && formik.errors.email && (
                                <FeildError>{formik.errors.email}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Password</FormLabel>
                            <input
                                type={'text'}
                                name={'password'}
                                onChange={formik.handleChange}
                                value={formik.values.password}
                                placeholder='Password'
                                disabled={(data?.employee_id) ? true : false}
                            />
                            {formik.touched.password && formik.errors.password && (
                                <FeildError>{formik.errors.password}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Password Confirmation</FormLabel>
                            <input
                                type={'text'}
                                name={'password_confirmation'}
                                onChange={formik.handleChange}
                                value={formik.values.password_confirmation}
                                placeholder='Password Confirmation'
                                disabled={(data?.employee_id) ? true : false}
                            />
                            {formik.touched.password_confirmation && formik.errors.password_confirmation && (
                                <FeildError>{formik.errors.password_confirmation}</FeildError>
                            )}
                        </FeildWraper>

                        <FormLineBreak />
                        <FormHeading1>Department Information</FormHeading1>

                        {/* Department */}
                        <FeildWraper>
                            <FormLabel required>Department</FormLabel>
                            <SelectSearch
                                name="department"
                                placeholder='- Select Department -'
                                onChange={(val) => {
                                    formik.setFieldValue("department", val);
                                    getDeptUsersList(val);
                                    formik.setFieldValue("reporting_authority", ""); // reset RA
                                }}
                                value={formik.values.department}
                                options={state?.getDropdowns?.departmentList.map((el) => ({
                                    label: el.title,
                                    value: el.id,
                                }))}
                            />
                            {formik.touched.department && formik.errors.department && (
                                <FeildError>{formik.errors.department}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Designation</FormLabel>
                            <input
                                type={'text'}
                                name={'designation'}
                                onChange={formik.handleChange}
                                value={formik.values.designation}
                                placeholder='Designation'
                            />
                            {formik.touched.designation && formik.errors.designation && (
                                <FeildError>{formik.errors.designation}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Role</FormLabel>
                            <input
                                type={'text'}
                                name={'role'}
                                onChange={formik.handleChange}
                                value={formik.values.role}
                                placeholder='Role'
                            />
                            {formik.touched.role && formik.errors.role && (
                                <FeildError>{formik.errors.role}</FeildError>
                            )}
                        </FeildWraper>

                        {/* Job Type */}
                        <FeildWraper>
                            <FormLabel required>Job Type</FormLabel>
                            <SelectSearch
                                name="job_type"
                                placeholder='- Select Job Type -'
                                onChange={(val) => { formik.setFieldValue("job_type", val); }}
                                value={formik.values.job_type}
                                options={[
                                    { label: "Part Time", value: "1" },
                                    { label: "Full Time", value: "2" },
                                ]}
                            />
                            {formik.touched.job_type && formik.errors.job_type && (
                                <FeildError>{formik.errors.job_type}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Salary</FormLabel>
                            <input
                                type={'number'}
                                name={'salary'}
                                onChange={formik.handleChange}
                                value={formik.values.salary}
                                placeholder='Salary'
                            />
                            {formik.touched.salary && formik.errors.salary && (
                                <FeildError>{formik.errors.salary}</FeildError>
                            )}
                        </FeildWraper>

                        {/* Employee Type */}
                        <FeildWraper>
                            <FormLabel>Employee Type</FormLabel>
                            <SelectSearch
                                name="employee_type"
                                placeholder='- Select Employee Type -'
                                onChange={(val) => { formik.setFieldValue("employee_type", val); }}
                                value={formik.values.employee_type}
                                options={[
                                    { label: "Probation", value: "Probation" },
                                    { label: "Permanent", value: "Permanent" },
                                    { label: "Internship", value: "Internship" },
                                ]}
                            />
                            {formik.touched.employee_type && formik.errors.employee_type && (
                                <FeildError>{formik.errors.employee_type}</FeildError>
                            )}
                        </FeildWraper>

                        {/* Reporting Authority */}
                        <FeildWraper>
                            <FormLabel required>Reporting Authority</FormLabel>
                            <SelectSearch
                                name="reporting_authority"
                                placeholder='- Select Reporting Authority -'
                                onChange={(val) => {
                                    getDeptUsersList(val);
                                    formik.setFieldValue("reporting_authority", val);
                                }}
                                value={formik.values.reporting_authority}
                                menuPlacement='top'
                                options={deptUserList.map((el) => ({
                                    label: el.employee_name,
                                    value: el.employee_id,
                                }))}
                                isDisabled={!deptUserList?.length}
                            />
                            {formik.touched.reporting_authority && formik.errors.reporting_authority && (
                                <FeildError>{formik.errors.reporting_authority}</FeildError>
                            )}
                        </FeildWraper>

                        <FormLineBreak />
                        <FormHeading1>Other Details</FormHeading1>

                        {/* Shift */}
                        <FeildWraper>
                            <FormLabel required>Shift</FormLabel>
                            <SelectSearch
                                name="shift"
                                placeholder='- Select Shift -'
                                onChange={(val) => { formik.setFieldValue("shift", val); }}
                                value={formik.values.shift}
                                menuPlacement='top'
                                options={Object.entries(state?.getDropdowns?.shiftList).map(([key, val]) => ({
                                    label: val,
                                    value: val,
                                }))}
                            />
                            {formik.touched.shift && formik.errors.shift && (
                                <FeildError>{formik.errors.shift}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Joining Date</FormLabel>
                            <DatePicker
                                selected={formik.values.joining_date}
                                onChange={(date) => formik.setFieldValue("joining_date", date)}
                                dateFormat="dd-MMMM-yyyy"
                                placeholderText="DD/MM/YYYY"
                                className="form-control"
                            />
                            {formik.touched.joining_date && formik.errors.joining_date && (
                                <FeildError>{formik.errors.joining_date}</FeildError>
                            )}
                        </FeildWraper>
                    </FormArea>
                </div>

                <div className={Style.modal_foot}>
                    <div className={`${Style.dcmb__cancel} opacity-0 pointer-events-none cursor-default`}>Cancel</div>
                    <button type="submit" className={Style.dcmb__submit}>Submit</button>
                </div>
            </form>

            <Snackbar open={alertData?.isShow} autoHideDuration={3000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={alertData?.type}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {alertData?.message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default AddUpdateEmployee
